
const getBranchId = ({isBranchGuide, isBusinessGuide}) => {
  if(isBranchGuide && isBusinessGuide){
    return 172;
  }else if(isBranchGuide && !isBusinessGuide){
    return 171;
  }else if(!isBranchGuide && isBusinessGuide){
    return 173;
  }else {
    return 170;
  }
};

export default getBranchId;
